import CommentObjectType from './CommentObjectType';
import { FLOATING_SIDEBAR_TOUR_ID, RESOLVABLE_COMMENTS_TOUR_ID } from './tourIDs';
const floatingSidebarTourBlockList = [CommentObjectType.REPORTING_DASHBOARD];
const onboardingTourBlockListedObjectTypes = {
  [FLOATING_SIDEBAR_TOUR_ID]: floatingSidebarTourBlockList,
  [RESOLVABLE_COMMENTS_TOUR_ID]: []
};
export default onboardingTourBlockListedObjectTypes;